import React from 'react';
import MostUsedSituationWidget from '../MostUsedSituationWidget/MostUsedSituationWidget';
import { createUseStyles } from 'react-jss';
import DeviceSummaryWidget from '../DeviceSummaryWidget/DeviceSummaryWidget';
import { useGetDiaryStatisticsQuery, useGetMostUsedSituationsQuery, useGetRecentDevicesQuery } from '../../api/phoenix';
import StatisticWidget from '../StatisticWidget/StatisticWidget';

interface WidgetsProps {
  id: string;
}

const Widgets: React.FC<WidgetsProps> = ({ id }) => {
  const classes = useStyles();

  const { data: situationsData, isLoading: isMostUsedSituationsLoading } = useGetMostUsedSituationsQuery(
    {
      id: id || '',
    },
    { skip: !id }
  );

  const { data: recentDevicesData, isLoading: isRecentDevicesLoading } = useGetRecentDevicesQuery(
    {
      id: id || '',
    },
    { skip: !id }
  );

  const { data: diaryStatisticsData, isLoading: isDiaryStatisticsLoading } = useGetDiaryStatisticsQuery(
    {
      id: id || '',
    },
    { skip: !id }
  );

  return (
    <div className={classes.container}>
      <div className={classes.widgetsGrid}>
        <StatisticWidget diaryStatistics={diaryStatisticsData?.data} isLoading={isDiaryStatisticsLoading} />
        <MostUsedSituationWidget
          isLoading={isMostUsedSituationsLoading}
          situations={situationsData?.data.situations || []}
        />
        <div className={classes.recentDevicesContainer}>
          {isRecentDevicesLoading && <DeviceSummaryWidget variant="neutral" isLoading={isRecentDevicesLoading} />}
          {recentDevicesData?.data.recentDevices.map((device, index, array) => (
            <DeviceSummaryWidget
              key={device.id}
              device={device}
              variant={index === 0 && array.length === 2 && device.positivityPercentage > 0 ? 'positive' : 'neutral'}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    marginBottom: 30,
  },
  widgetsGrid: {
    display: 'grid',
    gap: 15,
    gridTemplateColumns: 'repeat(3, 1fr)',
    '@media (max-width: 1200px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      '& > div:last-child': {
        gridColumn: '1 / -1',
      },
    },
  },
  recentDevicesContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: 15,
  },
});

export default Widgets;
